"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandsFilterBar = void 0;
require("../css/brands-filter-bar.scss");
var api_constants_1 = require("./constants/api-constants");
var constants_1 = require("./constants/constants");
var queryString = require('query-string');
var GenericFunctions = require("./generic-functions");
var categories_menu_1 = require("./categories-menu");
var filter_manager_1 = require("./filter-manager");
var BrandsFilterBar = /** @class */ (function () {
    function BrandsFilterBar() {
    }
    BrandsFilterBar.init = function () {
        if ($(BrandsFilterBar.classSelector + " li").length > 0) {
            //events
            $(BrandsFilterBar.classSelector + " li input[type=checkbox]").off("change");
            $(BrandsFilterBar.classSelector + " li input[type=checkbox]").on("change", filter_manager_1.FilterManager.setBrands);
            //check preselected brands
            filter_manager_1.FilterManager.getCurrentBrandsFilter();
        }
        BrandsFilterBar.setStatus();
    };
    BrandsFilterBar.loadData = function (memberNr) {
        $(BrandsFilterBar.classSelector).addClass("loading-content");
        var promise = $.get({
            url: window.BaseUrlWithVersions + "/" + api_constants_1.ApiConstants.ProductSearchBase + "/" + categories_menu_1.CategoriesMenu.currentCategory + "/" + api_constants_1.ApiConstants.ProductSearchBrands + location.search,
        });
        promise.done(function (data) {
            var callBack = function () {
                $(BrandsFilterBar.classSelector).html(data);
                BrandsFilterBar.init();
            };
            GenericFunctions.ajaxResponseRedirectIfNeeded(data, callBack);
        });
        promise.fail(function () {
            $("#generic-error-modal #error-text").text(constants_1.Constants.ErrorGettingBrands);
            $("#generic-error-modal").modal("show");
        });
        promise.always(function () {
            $(BrandsFilterBar.classSelector).removeClass("loading-content");
        });
    };
    BrandsFilterBar.isLoadNeeded = function () {
        var parsed = queryString.parse(location.search);
        var data = categories_menu_1.CategoriesMenu.currentCategory + "&" + parsed.MainProperties + "&" + parsed.SubCategoryId + "&" + parsed.Features;
        return data != BrandsFilterBar.LastComponentStatus;
    };
    BrandsFilterBar.setStatus = function () {
        var parsed = queryString.parse(location.search);
        var data = categories_menu_1.CategoriesMenu.currentCategory + "&" + parsed.MainProperties + "&" + parsed.SubCategoryId + "&" + parsed.Features;
        BrandsFilterBar.LastComponentStatus = data;
    };
    BrandsFilterBar.classSelector = ".brands-filter-bar";
    return BrandsFilterBar;
}());
exports.BrandsFilterBar = BrandsFilterBar;
